"use strict";

import commonBondViewTemplate from "./CommonBondViewTemplate";
import studentLoanEvents from "./events/StudentLoanEvents";

var CommonBondDirective = function (
    $location,
    $window,
    $modal,
    samlTokenService,
    paeService,
    eventBus,
    $translate
) {
    return {
        restrict: "E",
        scope: {
            factoryName: "@",
            //uniqueId is the string to append to the form id
            uniqueId: "@"
        },
        template: commonBondViewTemplate,
        controller: [
            "$scope",
            "$rootScope",
            function ($scope, $rootScope) {
                $scope.continueClick = function () {
                    if (!$scope.isPae) {
                        eventBus.dispatch(studentLoanEvents.CONTINUE_CLICKED, this);
                        var ssoWindow = window.window;
                        samlTokenService.navigateToken("Candidly", ssoWindow, $scope.uniqueId);
                    } else {
                        $window.location.href = "/participant/accounts/#/accessDeniedError/44403";
                    }
                };
                $scope.dismiss = function () {
                    eventBus.dispatch(studentLoanEvents.CANCEL_CLICKED, this);
                    window.close();
                };

                $rootScope.$on("$translateChangeSuccess", function () {
                    $scope.translations = {
                        empowerPolicyLink: $translate.instant(
                            "accountList.commonBond.empowerPolicyLink"
                        ),
                        commonBondPolicyLink: $translate.instant(
                            "accountList.commonBond.commonBondPolicyLink"
                        ),
                        empowerCommonbondTermsPDF: $translate.instant(
                            "accountList.commonBond.empowerCommonbondTermsPDF"
                        ),
                        defaultCommonBondFlag: $translate.instant(
                            "accountList.commonBond.defaultCommonBondFlag"
                        )
                    };
                });
            }
        ],

        link: function ($scope, element, attrs) {
            var isPaePromise = paeService.checkPaeUser();
            isPaePromise.then(
                function (pae) {
                    $scope.isPae = pae.partnerSSOResponse;
                },
                function (reason) {
                    $scope.isPae = true;
                }
            );
        }
    };
};
CommonBondDirective.$inject = [
    "$location",
    "$window",
    "$modal",
    "samlTokenService",
    "paeService",
    "eventBus",
    "$translate"
];
export default CommonBondDirective;
